import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
	dsn: 'https://b3f4d150afc08f757bc56c18c3346db8@o4506739662716928.ingest.us.sentry.io/4506739690242048',
	integrations: [Sentry.browserTracingIntegration()],
	tracesSampleRate: environment.production ? 0.2 : 0.0,
	enabled: environment.production,
});

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
	.catch((err) => console.error(err));
